import React from "react";
import styled from 'styled-components/macro';

interface PropsI {
  children: React.ReactNode;
}

const PanelTitle = (props: PropsI) => {
  return(
    <Title>
      {props.children}
    </Title>
  )
}
export default PanelTitle;

const Title = styled.div`
  color: ${(p) => p.theme.palette.titlePrimary};
  font-size: 18px;
  font-weight: ${(p) => p.theme.weights.heavy};
  padding-left: 15px;
  margin-top: 5px;
  margin-bottom: 5px;
`;